import React, { useState, useEffect, useRef } from "react";
import { API } from "aws-amplify";
import { v4 as uuidv4 } from 'uuid';
import CustomStepper from "../components/CustomStepper2";
import CustomTabs from "../components/CustomTabs2";
import { Box } from "@mui/material";
import Paper from '@material-ui/core/Paper';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import DownloadIcon from '@material-ui/icons/GetApp';
import IconButton from '@material-ui/core/IconButton';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { HighlightWithinTextarea } from 'react-highlight-within-textarea';
import LoadingModal from "./LoadingModal";
import InsertsChecklist from "./InsertsCheckList";
import "../containers/Prompt.css";

export default function TabArtefactise(props) {
    const { project, docRef, updateConfig, config, updateSteps, onDocUpdated, disabled, models } = props;

    //const [tabStep, setTabStep] = useState(0);
    const [activeStep, setActiveStep] = React.useState(-1);
    const [tabProcess, setTabProcess] = useState(0);

    const [promptUserP1, setPromptUserP1] = useState("");
    const [promptSysP1, setPromptSysP1] = useState("");
    const [promptUserP2, setPromptUserP2] = useState("");
    const [promptSysP2, setPromptSysP2] = useState("");
    //const [promptUserP3, setPromptUserP3] = useState("");
    //const [promptSysP3, setPromptSysP3] = useState("");
    //const [validatorOptions, setValidatorOptions] = useState("");
    const [validatorResults, setValidatorResults] = useState("");
    // const [enrichedNtab, setEnrichedNtab] = useState("");
    const [p1Results, setP1Results] = useState("");
    const [p2Results, setP2Results] = useState("");
    //const [p3Results, setP3Results] = useState("");

    const [targetChars, setTargetChars] = useState(12000);
    const [maxChars, setMaxChars] = useState(15000);

    const [temperature, setTemperature] = useState(0.0);
    const [topP, setTopP] = useState(1.0);
    const [presencePenalty, setPresencePenalty] = useState(0.0);
    const [frequencyPenalty, setFrequencyPenalty] = useState(0.0);
    const [selectedModel, setSelectedModel] = useState("gpt-4.1-mini");

    const [promptId, setPromptId] = useState(null);

    const [copied, setCopied] = useState(false);

    const [processingState, setProcessingState] = useState({ currentIndex: 0, isActive: false, userKey: 1, artefactionState: 0, tempId: null });
    const [isRunning, setIsRunning] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [resultsStatus, setResultsStatus] = useState('');

    const [isCancelling, setIsCancelling] = useState(false);
    const [resultsData, setResultsData] = useState("");

    const startTimeRef = useRef(0);

    const indexRef = useRef(0);
    const processTextRef = useRef("");

    const [statusText, setStatusText] = useState("");
    const [processText, setProcessText] = useState("");

    const steps = [
        { id: 1, title: "P1", subtitle: "", code: "P1", extractionType: "p1", completed: false, exists: false },
        { id: 2, title: "P2", subtitle: "", code: "P2", extractionType: "p2", completed: false, exists: false },
        /*{ id: 3, title: "P3", subtitle: "", code: "P3", extractionType: "p3", completed: false, exists: false },
        { id: 4, title: "Validation", code: "Validation", extractionType: "validation", subtitle: "", completed: false, exists: false },*/
    ];


    useEffect(() => {
        clearResults();
        updateTabsAndSteps();
        loadConfig();
    }, []);

    useEffect(() => {
        updateTabsAndSteps();
    }, [docRef.current]); //





    useEffect(() => {
        let pollingInterval;
        if (isRunning) {
            pollingInterval = setInterval(updateResultsStatus, 300); // Check every 5 seconds
        }
        try {
            return () => {
                clearInterval(pollingInterval);
            } // Clear polling on unmount or when parsing stops
        } catch (e) {
            // do nowt
        }
    }, [isRunning]); //

    const updateResultsStatus = () => {
        const timeDiff = (Date.now() - startTimeRef.current) / 1000;
        setResultsStatus(timeDiff)
    }

    function clearResults() {
        setP1Results("");
        setP2Results("");
        //setP3Results("");
        setValidatorResults("");
    }

    function updateTabsAndSteps() {
        const updatedSteps = [];
        for (const step of steps) {
            let updatedStep;
            console.log(step);
            /*
            if (docRef.current.parseState && docRef.current.parseState.ntabs) {
              if (docRef.current.parseState.ntabs[step.code]) {
                updatedStep = { ...step, exists: true, completed: docRef.current.parseState.ntabs[step.code].status == 1 }
              } else {
                updatedStep = { ...step, exists: false, completed: false }
              }
            } else {
              updatedStep = { ...step, exists: false, completed: false }
            }
              
            updatedSteps.push(updatedStep);
            */
        }
        //setSteps(updatedSteps);
        console.log(steps);
    }

    function getOpenAI(body) {
        return API.post("findigai", "/openai", {
            body: body
        });
    }

    function getResults(body) {
        return API.post("findigai", "/results/mode", {
            body: body
        });
    }

    /*
    function validate(body) {
        return API.post("findigai", "/validation", {
            body: body
        });
    }
        */

    function handleTabChange(event, value) {
        event.preventDefault();
        //console.log(value);
        setTabProcess(value);
        //setTabStep(value);
    };





    const loadConfig = () => {
        console.log(config);
        console.log(config.art);
        console.log(config.art.options);
        const cf = config.art.options;
        setPromptUserP1(cf?.promptUserP1 || "");
        setPromptSysP1(cf?.promptSysP1 || "");
        setPromptUserP2(cf?.promptUserP2 || "");
        setPromptSysP2(cf?.promptSysP2 || "");
        //setPromptUserP3(cf?.promptUserP3 || "");
        //setPromptSysP3(cf?.promptSysP3 || "");
        //setSdoList(cf?.sdos || "");
        //setValidatorOptions(cf?.validator || "");

        setTargetChars(cf?.targetChars || 12000);
        setMaxChars(cf?.maxChars || 15000);
        setTemperature(cf?.temperature || 0.0);
        setTopP(cf?.topP || 1.0);
        setPresencePenalty(cf?.presencePenalty || 0.0);
        setFrequencyPenalty(cf?.frequencyPenalty || 0.0);
        setSelectedModel(cf?.model || "");
    }
    const handleRestartArtefactsClick = async (event) => {
        event.preventDefault();
        startTimeRef.current = Date.now();
        setIsRunning(true);
        clearResults();
        await runPxQuery({ restart: true });
    }

    const handleProcessArtefactsClick = async (event) => {
        event.preventDefault();
        startTimeRef.current = Date.now();
        setIsRunning(true);
        clearResults();
        await runPxQuery();
    }
    /*
        async function deleteAllExisting() {
            console.log("Delete-all: pk=", docRef.current.itemId);
            await getResults({ pk: docRef.current.itemId, sk: "", mode: "delete-all" });
        }
    */
    async function runPxQuery(params = {}) {
        //console.log(type, params);
        const uuid = uuidv4();
        //const newUserKey = processingState.userKey === 2 ? 1 : 2;
        //setProcessingState({ ...processingState, userKey: newUserKey, tempId: uuid });
        let resultsStr = "";
        try {
            //const body = { ...params, type: "artefactisation4", subtype: type, prjid: project.itemId, docid: docRef.current.itemId, uuid, keyId: newUserKey, config: getConfigObj() };
            //const body = { ...params, type: "artefactisation5", subtype: type, prjid: project.itemId, docid: docRef.current.itemId, uuid, keyId: newUserKey, config: getConfigObj() };
            const body = { ...params, type: "artefactisation7", /*subtype: type,*/ prjid: project.itemId, docid: docRef.current.itemId/*, uuid, keyId: newUserKey*/, config: getConfigObj() };
            console.log(body);
            const result = await getOpenAI(body);
            console.log(result);
            resultsStr = result.body;
            //setPromptId(type);
            setIsProcessing(true);
            return { status: true, result: resultsStr };
        } catch (err) {
            console.log("OpenAI Error:", err?.response?.data || err.message || err);
            resultsStr = "OpenAI Error: " + err?.response?.data || err.message || err;
            return { status: true, result: resultsStr };
        }
    }

    useEffect(() => {
        let pollingInterval;
        if (isRunning && isProcessing) { //} && processingState.tempId) {
            pollingInterval = setInterval(pollStatus, 5000); // Check every 5 seconds
        }
        try {
            return () => clearInterval(pollingInterval); // Clear polling on unmount or when parsing stops
        } catch (e) {
            // do nowt
        }

    }, [isRunning, isProcessing]); // promptId]);

    const pollStatus = async () => {
        //const body = { pk: docRef.current.itemId, sk: `ART|TMP|${processingState.tempId}`, mode: "get" };
        const body = { pk: project.itemId, sk: `PRJ|DOC|${docRef.current.itemId}`, mode: "get" };
        const result = await getResults(body);
        //console.log("1111");
        if (result.status && result.data) {
            const doc = result.data;
            onDocUpdated(doc);
            //console.log("2222");
            //await getResults({ ...body, mode: "delete" });
            //const currentPromptId = promptId;
            //setProcessingState({ ...processingState, tempId: null });
            //setPromptId(null);

            const { state } = doc.pipeline;
            //setIsProcessing(false);
            if (doc.pipeline.subType === "P1") {
                console.log("........................................................................................");
                for (let i = 0; i < doc.pipeline.artefaction.chunks.length; i++) {
                    console.log(i, doc.pipeline.artefaction.chunks[i].state);
                }
            } else {
                console.log(state);
            }
            //const allComplete = doc.pipeline.artefaction.chunks.every(chunk => chunk.state === "complete");

            //const { next_uber_id, last_artefact_id, last_batch_id } = result.data.content;

            //console.log("Artefaction Retry State: ", processingState.artefactionState);
            //if (result.data.itemStatus > 0) {
            //if (next_uber_id) {
            if (state !== "complete") {
                //const allComplete = doc.pipeline.artefaction.chunks.every(chunk => chunk.state === "complete");
                //if (doc.pipeline.subType === "P1" && allComplete) {
                //    await runPxQuery();
                //}
   
                // do nowt
            } else {
                setIsProcessing(false);
                setIsRunning(false);
                downloadResults("P1", false);
                downloadResults("P2", false);
                /*
                if (currentPromptId == "P1") {

                    downloadResults("P1", false);
                    //setIsRunning(false);
                    //return;

                    console.log("P2 querying");
                    setProcessText("P2 querying");
                    runPxQuery("P2", { start_uber_id: null, lastArtefactId: 0, batch_id: 0, targetChars, maxChars });
                } else if (currentPromptId == "P2") {
                    console.log("Validating");
                    setProcessText("Validating");
                    //const valResult = await validate({ type: "MAIN-NTAB", docid: docRef.current.itemId, artid: ntabArtefacts[indexRef.current].itemId });
                    //console.log(valResult);
                    updateSteps(1, true);
                    //downloadResults("P1", false);

                    downloadResults("P1", false);
                    //downloadResults("P3", false);
                    //downloadResults("VAL", false);

                    setIsRunning(false);
                    //alert("Artefaction processing succeded");
                }
                    */
            }
            /*} else {
                //console.log(details);
                let tChars = targetChars;
                let mChars = maxChars;
                switch (processingState.artefactionState) {
                    case 0:
                        // do nowt, just rerun from the same cursor but on a different openAi key
                        break;
                    case 1:
                        tChars = parseInt(tChars * (3 / 4));
                        mChars = parseInt(mChars * (3 / 4));
                        break;
                    case 2:
                        tChars = parseInt(tChars * (2 / 4));
                        mChars = parseInt(mChars * (2 / 4));
                        break;
                    case 3:
                        tChars = parseInt(tChars * (1 / 4));
                        mChars = parseInt(mChars * (1 / 4));
                        break;
                }
                if (processingState.artefactionState < 4) {
                    //await runPxQuery(currentPromptId, { start_uber_id: next_uber_id, lastArtefactId: last_artefact_id, batch_id: last_batch_id, targetChars: tChars, maxChars: mChars });
                    await runPxQuery(currentPromptId, { start_item_id: next_item_id, lastArtefactId: last_artefact_id, batch_id: last_batch_id, targetChars: tChars, maxChars: mChars });
                } else {
                    console.log("Could not complete, ran out of attempts.");
                    setIsRunning(false);
                    updateSteps(1, false, true, true);
                    setProcessingState({ ...processingState, artefactionState: 0 });
                    alert("Could not complete Artefaction, ran out of attempts.");
                    return;
                }
                const newArtState = processingState.artefactionState + 1;
                setProcessingState({ ...processingState, artefactionState: newArtState });
                //setArtefactionState(artefactionState + 1);
            }*/
        } else if (result.error && result.findigCode && result.findigCode == 3) {
            // Do nowt ie record not yet created
        } else {
            setIsRunning(false);
            alert("Artefaction Failed - see logs")
        }
    }


    const saveConfig = async () => {
        startTimeRef.current = Date.now();
        setIsRunning(true);
        const body = getConfigObj();
        await updateConfig(body);
        setIsRunning(false);
        // resetResults();
    }



    function getConfigObj() {
        return { type: "art", values: { options: { promptSysP1: promptSysP1, promptUserP1: promptUserP1, promptSysP2: promptSysP2, promptUserP2: promptUserP2, targetChars, maxChars, model: selectedModel, temperature: temperature, topP: topP, presencePenalty: presencePenalty, frequencyPenalty: frequencyPenalty } } };
    }

    const handleTargetCharsChange = async (e) => {
        e.preventDefault();
        let newValue = Number(e.target.value);
        if (newValue > 50000) newValue = 50000;
        if (newValue < 1000) newValue = 1000;
        if (newValue > maxChars) newValue = maxChars;
        setTargetChars(newValue);
    }
    const handleMaxCharsChange = async (e) => {
        e.preventDefault();
        let newValue = Number(e.target.value);
        if (newValue > 50000) newValue = 50000;
        if (newValue < 1000) newValue = 1000;
        if (newValue < targetChars) newValue = targetChars;
        setMaxChars(newValue);
    }
    const handleTopPChange = async (e) => {
        e.preventDefault();
        let newValue = Number(e.target.value);
        if (newValue >= 1) newValue = 1.0;
        if (newValue < 1) newValue = 0.0;
        setTopP(newValue);
    }
    const handleTemperatureChange = async (e) => {
        e.preventDefault();
        let newValue = Number(e.target.value);
        if (newValue >= 1) newValue = 1.0;
        if (newValue < 1) newValue = 0.0;
        setTemperature(newValue);
    }
    const handlePresencePenaltyChange = async (e) => {
        e.preventDefault();
        let newValue = Number(e.target.value);
        if (newValue >= 1) newValue = 1.0;
        if (newValue < 1) newValue = 0.0;
        setPresencePenalty(newValue);
    }
    const handleFrequencyPenaltyChange = async (e) => {
        e.preventDefault();
        let newValue = Number(e.target.value);
        if (newValue >= 1) newValue = 1.0;
        if (newValue < 1) newValue = 0.0;
        setFrequencyPenalty(newValue);
    }

    const handleValidatorOnlyClick = async (event) => {
        //validateNTAB(enrichedNtab);

    }

    const copyToClipboard = (e, stage) => {
        e.preventDefault();
        let text = "";
        switch (stage) {
            case "P1":
                text = p1Results;
                break;
            case "P2":
                text = p1Results;
                break;
            /*case "P3":
                text = p1Results;
                break;*/
            case "VAL":
                text = p1Results;
                break;
        }
        navigator.clipboard.writeText(text)
            .then(() => {
                console.log("Text copied to clipboard!");
                setCopied(true);
                setTimeout(() => setCopied(false), 1500); // hide after 2 sec
            })
            .catch(err => {
                console.error("Failed to copy: ", err);
            });
    }




    const downloadResults = async (stage, timer = false) => {
        if (timer) {
            startTimeRef.current = Date.now();
            setIsRunning(true);
        }
        let body = { pk: docRef.current.itemId, sk: `ART|${stage}|`, mode: "query" };
        const results = await getResults(body);
        let text = "";
        for (const tab of results.data) {
            if (stage === "VAL") {
                //text += `<b>${tab.sk}</b> ----------------------------------------------------------------------------------------------------------------------------<br/><br/>`;
                //text += setValidationResults(tab.content);
                //text += `<br/>-------------------------------------------------------------------------------------------------------------------------------------<br/><br/>`;

            } else {
                text += `${tab.sk}\n`;
                text += JSON.stringify(tab.content, null, 2);
                text += `\n-------------------------------------------------------------------------------------------------------------------------------------\n\n`;

            }
        }
        //console.log(text);
        switch (stage) {
            case "P1":
                setP1Results(text);
                break;
            case "P2":
                setP2Results(text);
                break;
            /*case "P3":
                setP3Results(text);
                break;*/
            case "VAL":
                //setValidatorResults(text);
                break;
        }
        if (timer) {
            setIsRunning(false);
        }
    }




    const loadResults = async (e, stage) => {
        e.preventDefault();
        downloadResults(stage, true);
    }


    /////////////////////////////////////////////////// CHUNKING /////////////////////////////////////////////////////////////////

    function makeChunks(docText, opts = {}) {
        const targetChars = opts.targetChars ?? 35_000;
        const minChars = opts.minChars ?? Math.floor(targetChars * 0.7);
        const overlapChars = opts.overlapChars ?? 3_000;
        const boundaryWindow = opts.boundaryWindow ?? 2_000;

        const chunks = [];
        let start = 0;

        while (start < docText.length) {
            // Propose an end based on target size
            let proposedEnd = Math.min(docText.length, start + targetChars);

            // If remaining text is small, just take the rest (but still marker-safe)
            if (docText.length - start <= minChars) {
                const end = clampOffMarkerEnd(docText, docText.length);
                chunks.push(makeChunkRecord(docText, chunks, start, end, overlapChars));
                break;
            }

            // Pick best boundary near proposedEnd (search backward)
            let end = findBestBoundary(docText, start, proposedEnd, boundaryWindow);

            // Ensure chunk is not too small; if it is, fallback to proposedEnd (marker-safe)
            if (end - start < minChars) {
                end = proposedEnd;
            }

            // Final safety: do not end inside marker
            end = clampOffMarkerEnd(docText, end);

            // Also ensure start isn’t inside marker (can happen due to overlap)
            start = clampOffMarkerStart(docText, start);

            // If after clamping we got a degenerate chunk, hard advance
            if (end <= start) {
                const hardEnd = Math.min(docText.length, start + minChars);
                const safeHardEnd = clampOffMarkerEnd(docText, hardEnd);
                chunks.push(makeChunkRecord(docText, chunks, start, safeHardEnd, overlapChars));
                start = safeHardEnd;
                continue;
            }

            chunks.push(makeChunkRecord(docText, chunks, start, end, overlapChars));

            // Next start uses overlap
            start = Math.max(0, end - overlapChars);
        }

        return chunks;
    }

    function makeChunkRecord(docText, chunks, start, end, overlapChars) {
        const chunkId = chunks.length;

        const prev = chunks[chunks.length - 1];
        const overlapStart = prev ? Math.max(start, prev.end - overlapChars) : null;
        const overlapEnd = prev ? prev.end : null;

        return {
            chunkId,
            start,         // global start (inclusive)
            end,           // global end (exclusive)
            overlapStart,  // null for first chunk
            overlapEnd,    // null for first chunk
            text: docText.slice(start, end),
        };
    }

    function findBestBoundary(docText, start, proposedEnd, boundaryWindow) {
        const windowStart = Math.max(start, proposedEnd - boundaryWindow);
        const slice = docText.slice(windowStart, proposedEnd);

        // Priority 1: Cut before a page marker
        // We search for the last occurrence of "\n<<<PAGE:" or "<<<PAGE:" in the window.
        // Cutting right before marker keeps marker at the start of next chunk.
        let idx = slice.lastIndexOf("\n<<<PAGE:");
        if (idx !== -1) return windowStart + idx + 1; // +1 to cut at marker start

        idx = slice.lastIndexOf("<<<PAGE:");
        if (idx !== -1) return windowStart + idx;

        // Priority 2: Double newline boundary
        idx = slice.lastIndexOf("\n\n");
        if (idx !== -1) return windowStart + idx + 2;

        // Priority 3: Single newline
        idx = slice.lastIndexOf("\n");
        if (idx !== -1) return windowStart + idx + 1;

        // Fallback: hard cut
        return proposedEnd;
    }

    function clampOffMarkerStart(docText, pos) {
        // If pos is inside a marker, move it to the marker end + newline (i.e., first content char)
        const markerRange = findMarkerRangeContaining(docText, pos);
        if (!markerRange) return pos;

        // markerRange.end is index after ">>>"
        // Typically marker is followed by "\n", so skip it if present
        let newPos = markerRange.end;
        if (docText[newPos] === "\n") newPos += 1;
        return newPos;
    }

    function clampOffMarkerEnd(docText, pos) {
        // If end is inside a marker, move it back to marker start (so chunk ends before marker)
        const markerRange = findMarkerRangeContaining(docText, pos);
        if (!markerRange) return pos;

        return markerRange.start;
    }

    function findMarkerRangeContaining(docText, pos) {
        // Find nearest "<<<PAGE:" before pos, ensure its matching ">>>" is after pos.
        const start = docText.lastIndexOf("<<<PAGE:", pos);
        if (start === -1) return null;

        const end = docText.indexOf(">>>", start);
        if (end === -1) return null;

        const markerEnd = end + 3; // exclusive
        if (pos >= start && pos < markerEnd) {
            return { start, end: markerEnd };
        }
        return null;
    }

    /////////////////////////////////////////////////// END CHUNKING /////////////////////////////////////////////////////////////////




    function renderLander() {
        return (



            <Box p={0} sx={{ backgroundColor: "#fff" }}>
                <Box px={2} >
                    <h6> {Number(resultsStatus) > 0 ? String(Number(resultsStatus).toFixed(1)) + " seconds." : ""}</h6>
                </Box>
                <Box px={2} my={2} display="flex" alignItems='center' flexDirection="row" >
                    <Button disabled={isRunning || docRef.current.itemStatus < 1} onClick={handleProcessArtefactsClick} color="primary" variant="contained" component="span" startIcon={<PlayArrowIcon />}>Run artefaction pipeline</Button>
                    <Box pl={2}><Button disabled={isRunning || docRef.current.itemStatus < 1} onClick={handleRestartArtefactsClick} color="primary" variant="contained" component="span" startIcon={<PlayArrowIcon />}>Restart</Button></Box>
                </Box>

                <CustomStepper steps={steps} activeStep={activeStep} />
                <Box px={1} sx={{
                    width: '100%',
                    bgcolor: 'white',
                    color: 'white',
                }}>
                    <CustomTabs
                        tabs={steps}
                        value={tabProcess}
                        onChange={handleTabChange}
                    />
                    <Box p={2} sx={{
                        width: '100%',
                        bgcolor: '#33337733',
                        color: '#330',
                    }}>






                        <>



                            <Box mt={1} sx={{ width: "100%" }}>
                                <Paper style={{ backgroundColor: "#f2f2ff" }}>

                                    <Box p={2}>



                                        <Paper style={{ backgroundColor: "#efe" }}>
                                            <Box p={1}>



                                                {tabProcess == 0 ?
                                                    <>


                                                        <Paper style={{ backgroundColor: "#ffe" }}>
                                                            <Box p={1} mb={4}>



                                                                <Box display="flex" alignItems='center' flexDirection="row" >
                                                                    <Box pv={2} pl={0.5}>
                                                                        <h6>P1 results</h6>
                                                                    </Box>
                                                                    <Box sx={{ flexGrow: 1 }} ></Box>
                                                                    <Box mx={1} pb={1}>
                                                                        <Tooltip title="download existing results">
                                                                            <IconButton
                                                                                onClick={(e) => { loadResults(e, "P1") }}
                                                                                disabled={isRunning}
                                                                                size="small"
                                                                            >
                                                                                <DownloadIcon />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    </Box>
                                                                    <Box mx={1} pb={1}>
                                                                        <Tooltip title="Copy results to clipboard">
                                                                            <IconButton
                                                                                onClick={(e) => { copyToClipboard(e, "P1") }}
                                                                                disabled={isRunning}
                                                                                size="small"
                                                                            >
                                                                                <FileCopyIcon />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                        {copied && <span style={{ marginLeft: 10, color: 'green' }}>Copied!</span>}
                                                                    </Box>
                                                                </Box>




                                                                <TextareaAutosize
                                                                    disabled={true}
                                                                    placeholder="<empty>"
                                                                    minRows={1}
                                                                    value={p1Results}
                                                                    onChange={(e) => setP1Results(e.target.value)}
                                                                    style={{
                                                                        width: '100%',
                                                                        padding: '12px',
                                                                        fontSize: '16px',
                                                                        borderRadius: '8px',
                                                                        border: '1px solid #ccc',
                                                                        resize: 'vertical',
                                                                    }}

                                                                />

                                                            </Box>
                                                        </Paper>

                                                        <Box pv={2} pl={0.5}>
                                                            <h6>System prompt (P1)</h6>
                                                        </Box>
                                                        <Paper style={{ backgroundColor: "#fff" }}>
                                                            <Box p={1}>
                                                                <HighlightWithinTextarea
                                                                    disabled={isRunning}
                                                                    placeholder="<empty>"
                                                                    value={promptSysP1 ?? ""}
                                                                    highlight={[
                                                                        { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                                                        { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                                                        { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                                                    ]}
                                                                    onChange={(text) => setPromptSysP1(text)}
                                                                />
                                                            </Box>
                                                        </Paper>

                                                        <Box pt={3} pb={0} pl={0.5} >
                                                            <h6>User prompt (P1)</h6>
                                                        </Box>
                                                        <Box py={1}>
                                                            {/*<InsertsChecklist inserts={["{{{filtered-uber-blocks-batch}}}", "{{{artefact-lookup}}}", "{{{ntab-lookup}}}"]} text={promptUserP2} />*/}
                                                            <InsertsChecklist inserts={["{{{chunk}}}", "{{{metadata}}}", "{{{artefact-lookup}}}", "{{{ntab-lookup}}}"]} text={promptUserP1} />
                                                        </Box>

                                                        <Paper style={{ backgroundColor: "#fff" }}>
                                                            <Box p={1}>
                                                                <HighlightWithinTextarea
                                                                    disabled={isRunning}
                                                                    placeholder="<empty>"
                                                                    value={promptUserP1 ?? ""}
                                                                    highlight={[
                                                                        { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                                                        { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                                                        { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                                                    ]}
                                                                    onChange={(text) => setPromptUserP1(text)}
                                                                />
                                                            </Box>
                                                        </Paper>
                                                    </>
                                                    : tabProcess == 1 ?
                                                        <>

                                                            <Paper style={{ backgroundColor: "#ffe" }}>
                                                                <Box p={1} mb={4}>

                                                                    <Box display="flex" alignItems='center' flexDirection="row" >
                                                                        <Box pv={2} pl={0.5}>
                                                                            <h6>P2 results</h6>
                                                                        </Box>
                                                                        <Box sx={{ flexGrow: 1 }} ></Box>
                                                                        <Box mx={1} pb={1}>
                                                                            <Tooltip title="download existing results">
                                                                                <IconButton
                                                                                    onClick={(e) => { loadResults(e, "P2") }}
                                                                                    disabled={isRunning}
                                                                                    size="small"
                                                                                >
                                                                                    <DownloadIcon />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        </Box>
                                                                        <Box mx={1} pb={1}>
                                                                            <Tooltip title="Copy results to clipboard">
                                                                                <IconButton
                                                                                    onClick={(e) => { copyToClipboard(e, "P2") }}
                                                                                    disabled={isRunning}
                                                                                    size="small"
                                                                                >
                                                                                    <FileCopyIcon />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                            {copied && <span style={{ marginLeft: 10, color: 'green' }}>Copied!</span>}
                                                                        </Box>
                                                                    </Box>

                                                                    <TextareaAutosize
                                                                        disabled={isRunning}
                                                                        minRows={1}
                                                                        placeholder="<empty>"
                                                                        value={p2Results}
                                                                        onChange={(e) => setP2Results(e.target.value)}
                                                                        style={{
                                                                            width: '100%',
                                                                            padding: '12px',
                                                                            fontSize: '16px',
                                                                            borderRadius: '8px',
                                                                            border: '1px solid #ccc',
                                                                            resize: 'vertical',
                                                                        }}
                                                                    />
                                                                </Box>
                                                            </Paper>







                                                            <Box pv={2} pl={0.5}>
                                                                <h6>System prompt (P2)</h6>
                                                            </Box>
                                                            <Paper style={{ backgroundColor: "#fff" }}>
                                                                <Box p={1}>
                                                                    <HighlightWithinTextarea
                                                                        disabled={isRunning}
                                                                        placeholder="<empty>"
                                                                        value={promptSysP2 ?? ""}
                                                                        highlight={[
                                                                            { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                                                            { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                                                            { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                                                        ]}
                                                                        onChange={(text) => setPromptSysP2(text)}
                                                                    />
                                                                </Box>
                                                            </Paper>


                                                            <Box pt={3} pb={0} pl={0.5} >
                                                                <h6>User prompt (P2)</h6>
                                                            </Box>
                                                            <Box py={1}>
                                                                <InsertsChecklist inserts={["{{{tab-artefacts}}}"]} text={promptUserP2} />
                                                            </Box>
                                                            <Paper style={{ backgroundColor: "#fff" }}>
                                                                <Box p={1}>
                                                                    <HighlightWithinTextarea
                                                                        disabled={isRunning}
                                                                        placeholder="<empty>"
                                                                        value={promptUserP2 ?? ""}
                                                                        highlight={[
                                                                            { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                                                            { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                                                            { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                                                        ]}
                                                                        onChange={(text) => setPromptUserP2(text)}
                                                                    />
                                                                </Box>
                                                            </Paper>

                                                        </>

                                                        : tabProcess == 2 ?
                                                            <>

                                                                {/*}
                                                                <Paper style={{ backgroundColor: "#ffe" }}>
                                                                    <Box p={1} mb={4}>



                                                                        <Box display="flex" alignItems='center' flexDirection="row" >
                                                                            <Box pv={2} pl={0.5}>
                                                                                <h6>P3 results </h6>
                                                                            </Box>
                                                                            <Box sx={{ flexGrow: 1 }} ></Box>
                                                                            <Box mx={1} pb={1}>
                                                                                <Tooltip title="download existing results">
                                                                                    <IconButton
                                                                                        onClick={(e) => { loadResults(e, "P3") }}
                                                                                        disabled={isRunning}
                                                                                        size="small"
                                                                                    >
                                                                                        <DownloadIcon />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            </Box>
                                                                            <Box mx={1} pb={1}>
                                                                                <Tooltip title="Copy results to clipboard">
                                                                                    <IconButton
                                                                                        onClick={(e) => { copyToClipboard(e, "P3") }}
                                                                                        disabled={isRunning}
                                                                                        size="small"
                                                                                    >
                                                                                        <FileCopyIcon />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                                {copied && <span style={{ marginLeft: 10, color: 'green' }}>Copied!</span>}
                                                                            </Box>
                                                                        </Box>


                                                                        <TextareaAutosize
                                                                            disabled={isRunning}
                                                                            minRows={1}
                                                                            placeholder="<empty>"
                                                                            value={p3Results}
                                                                            onChange={(e) => setP3Results(e.target.value)}
                                                                            style={{
                                                                                width: '100%',
                                                                                padding: '12px',
                                                                                fontSize: '16px',
                                                                                borderRadius: '8px',
                                                                                border: '1px solid #ccc',
                                                                                resize: 'vertical',
                                                                            }}
                                                                        />
                                                                    </Box>
                                                                </Paper>

                                                                <Box pv={2} pl={0.5}>
                                                                    <h6>System prompt (P3)</h6>
                                                                </Box>

                                                                <Paper style={{ backgroundColor: "#fff" }}>
                                                                    <Box p={1}>
                                                                        <HighlightWithinTextarea
                                                                            disabled={isRunning}
                                                                            placeholder="<empty>"
                                                                            value={promptSysP3 ?? ""}
                                                                            highlight={[
                                                                                { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                                                                { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                                                                { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                                                            ]}
                                                                            onChange={(text) => setPromptSysP3(text)}
                                                                        />
                                                                    </Box>
                                                                </Paper>

                                                                <Box pt={3} pb={0} pl={0.5} >
                                                                    <h6>User prompt (P3)</h6>
                                                                </Box>
                                                                <Box py={1}>
                                                                    <InsertsChecklist inserts={["{{{presentation-style}}}", "{{{p2-output}}}", "{{{aspects}}}", "{{{cats}}}"]} text={promptUserP3} />
                                                                </Box>
                                                                <Paper style={{ backgroundColor: "#fff" }}>
                                                                    <Box p={1}>
                                                                        <HighlightWithinTextarea
                                                                            disabled={isRunning}
                                                                            placeholder="<empty>"
                                                                            value={promptUserP3 ?? ""}
                                                                            highlight={[
                                                                                { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                                                                { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                                                                { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                                                            ]}
                                                                            onChange={(text) => setPromptUserP3(text)}
                                                                        />
                                                                    </Box>
                                                                </Paper>
                                                                */}
                                                            </>
                                                            :
                                                            <>
                                                                <Box display="flex" alignItems='center' flexDirection="row" >
                                                                    <Box pv={2} pl={0.5}>
                                                                        <h6>Validation Results</h6>
                                                                    </Box>
                                                                    <Box sx={{ flexGrow: 1 }} ></Box>
                                                                    <Box mx={1} pb={1}>
                                                                        <Tooltip title="download existing results">
                                                                            <IconButton
                                                                                onClick={(e) => { loadResults(e, "VAL") }}
                                                                                disabled={isRunning}
                                                                                size="small"
                                                                            >
                                                                                <DownloadIcon />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    </Box>
                                                                    <Box mx={1} pb={1}>
                                                                        <Tooltip title="Copy results to clipboard">
                                                                            <IconButton
                                                                                onClick={(e) => { copyToClipboard(e, "VAL") }}
                                                                                disabled={isRunning}
                                                                                size="small"
                                                                            >
                                                                                <FileCopyIcon />
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                        {copied && <span style={{ marginLeft: 10, color: 'green' }}>Copied!</span>}
                                                                    </Box>
                                                                </Box>

                                                                <Box sx={{ p: 2, border: "1px solid #ccc" }}
                                                                    dangerouslySetInnerHTML={{ __html: validatorResults }}>
                                                                </Box>

                                                            </>
                                                }



                                            </Box>
                                        </Paper>


                                        {tabProcess < 3 &&
                                            <>
                                                <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                                                    <Box width={60} pt={3} pb={0} pl={0.5} >
                                                        <Paper>
                                                            <TextField
                                                                type="number"
                                                                disabled={isRunning || disabled}
                                                                value={targetChars}
                                                                onChange={handleTargetCharsChange}
                                                                disableUnderline
                                                                inputProps={{
                                                                    disableUnderline: true,
                                                                    min: 1000,
                                                                    max: 50000,
                                                                }}
                                                            />
                                                        </Paper>
                                                    </Box>
                                                    <Box pt={3} pb={0} pl={0.5} >
                                                        <h6> Target chars (per chunk)</h6>
                                                    </Box>
                                                </Box>
                                                <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                                                    <Box width={60} pt={3} pb={0} pl={0.5} >
                                                        <Paper>
                                                            <TextField
                                                                type="number"
                                                                disabled={isRunning || disabled}
                                                                value={maxChars}
                                                                onChange={handleMaxCharsChange}
                                                                disableUnderline
                                                                inputProps={{
                                                                    disableUnderline: true,
                                                                    min: 1000,
                                                                    max: 50000,
                                                                }}
                                                            />
                                                        </Paper>
                                                    </Box>
                                                    <Box pt={3} pb={0} pl={0.5} >
                                                        <h6> Maximum chars (per chunk)</h6>
                                                    </Box>
                                                </Box>
                                                <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                                                    <Box width={26} pt={3} pb={0} pl={0.5} >
                                                        <Paper>
                                                            <TextField
                                                                type="number"
                                                                disabled={isRunning}
                                                                value={temperature}
                                                                onChange={handleTemperatureChange}
                                                                disableUnderline
                                                                inputProps={{
                                                                    disableUnderline: true,
                                                                    min: 0,
                                                                    max: 1,
                                                                }}
                                                            />
                                                        </Paper>
                                                    </Box>
                                                    <Box pt={3} pb={0} pl={0.5} >
                                                        <h6> Temperature</h6>
                                                    </Box>
                                                </Box>

                                                <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                                                    <Box width={26} pt={3} pb={0} pl={0.5} >
                                                        <Paper>
                                                            <TextField
                                                                type="number"
                                                                disabled={isRunning}
                                                                value={topP}
                                                                onChange={handleTopPChange}
                                                                disableUnderline
                                                                inputProps={{
                                                                    disableUnderline: true,
                                                                    min: 0,
                                                                    max: 1,
                                                                }}
                                                            />
                                                        </Paper>
                                                    </Box>
                                                    <Box pt={3} pb={0} pl={0.5} >
                                                        <h6> Top P</h6>
                                                    </Box>
                                                </Box>

                                                <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                                                    <Box width={26} pt={3} pb={0} pl={0.5} >
                                                        <Paper>
                                                            <TextField
                                                                type="number"
                                                                disabled={isRunning}
                                                                value={presencePenalty}
                                                                onChange={handlePresencePenaltyChange}
                                                                disableUnderline
                                                                inputProps={{
                                                                    disableUnderline: true,
                                                                    min: 0,
                                                                    max: 1,
                                                                }}
                                                            />
                                                        </Paper>
                                                    </Box>
                                                    <Box pt={3} pb={0} pl={0.5} >
                                                        <h6> Presence penalty</h6>
                                                    </Box>
                                                </Box>
                                                <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                                                    <Box width={26} pt={3} pb={0} pl={0.5} >
                                                        <Paper>
                                                            <TextField
                                                                type="number"
                                                                disabled={isRunning}
                                                                value={frequencyPenalty}
                                                                onChange={handleFrequencyPenaltyChange}
                                                                disableUnderline
                                                                inputProps={{
                                                                    disableUnderline: true,
                                                                    min: 0,
                                                                    max: 1,
                                                                }}
                                                            />
                                                        </Paper>
                                                    </Box>
                                                    <Box pt={3} pb={0} pl={0.5} >
                                                        <h6> Frequency penalty</h6>
                                                    </Box>
                                                </Box>

                                                <Box my={2} ml={0.5}>
                                                    <select
                                                        id="model"
                                                        disabled={isRunning}
                                                        value={selectedModel}
                                                        onChange={(e) => setSelectedModel(e.target.value)}
                                                    >
                                                        {models.map((model) => (
                                                            <option key={model.value} value={model.value}>
                                                                {model.label}
                                                            </option>
                                                        ))}
                                                    </select>

                                                </Box>


                                                <Box pt={3} pb={0} pl={0.5} >
                                                    <p style={{ fontSize: "0.75rem" }}><i>Note: To save the prompts and params without running the query use the SAVE button. The prompts and params will be automatically saved if you run the query.</i></p>
                                                </Box>
                                                <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>
                                                    <Box sx={{ flexGrow: 1 }} ></Box>
                                                    <Box my={2} mr={3}>
                                                        <Button
                                                            variant="contained" component="span"
                                                            disabled={isRunning}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                saveConfig();
                                                            }} color="primary">
                                                            Save
                                                        </Button>
                                                    </Box>
                                                </Box>




                                            </>
                                        }


                                    </Box>
                                </Paper>
                            </Box>



                        </>






                    </Box>
                    <Box p={2} sx={{
                        width: '100%',
                        bgcolor: 'white',
                        color: 'white',
                    }}>
                    </Box>
                </Box>

            </Box>

        )
    }
    return (
        <>
            {renderLander()}
            {isRunning &&
                <LoadingModal open={isRunning} message={"Artefacting..."} message2={processText + "..."} message3={Number(resultsStatus).toFixed(1) + " seconds"} />
            }
        </>
    )
}